import React from "react";
import cns from "classnames";
import Checkbox from "@material-ui/core/Checkbox";
import MenuItem from "@material-ui/core/MenuItem";
import { Small } from "../typography/Small";
import { OptionComponentProps } from "./utils";
import { ThemeType } from "@theme";
import Highlighter from "@components/Highlighter";
import { makeStyles } from "@material-ui/core/styles";

export function SelectOptionCheckboxTwoLine(
  props: OptionComponentProps & { children?: React.ReactNode }
) {
  const classes = useStyles({});
  const {
    isDisabled,
    isGroup,
    isFocused,
    isSelected,
    isGroupOpen,
    handleDropdownItemClick,
    option
  } = props;

  const fontWeight = isSelected ? 500 : 400;

  const searchRe = props.inputValue ? new RegExp(props.inputValue, "i") : null;

  return (
    <MenuItem
      className={cns(props.className, classes.root, {
        [classes.menuWithDropdownItem]: isGroup,
        [classes.withDesc]: Boolean(props.option.description)
      })}
      component={"div" as any}
      disabled={isDisabled}
      onClick={() => props.onSelect(props.option)}
      onFocus={props.onFocus}
      selected={isFocused}
      style={{
        fontWeight,
        paddingLeft: 8 + props.parentLevel * 2 * 8
      }}
      data-test="SelectOption"
      data-test-id={props.option.value}
    >
      {!option.skipCheckbox && (
        <Checkbox
          checked={isSelected}
          className={classes.checkbox}
          disabled={isDisabled}
        />
      )}

      <div>
        <span>
          <Highlighter search={searchRe} style={{ flex: 1, whiteSpace: "normal" }}>
            {props.children}
          </Highlighter>
        </span>

        {props.option.description && (
          <Small style={{ display: "block" }}>
            <Highlighter search={searchRe}>{props.option.description}</Highlighter>
          </Small>
        )}
      </div>

      {isGroup && (
        <div className={classes.dropdownItem} onClick={handleDropdownItemClick}>
          <span
            className={cns(classes.dropdownArrow, {
              [classes.dropdownArrowOpen]: isGroupOpen
            })}
          >
            <svg
              fill="currentColor"
              preserveAspectRatio="xMidYMid meet"
              height="1em"
              width="1em"
              viewBox="0 0 40 40"
              style={{ verticalAlign: "middle" }}
            >
              <g>
                <path d="m11.6 16.6h16.8l-8.4 8.4z" />
              </g>
            </svg>
          </span>
        </div>
      )}
    </MenuItem>
  );
}

SelectOptionCheckboxTwoLine.defaultProps = {
  parentLevel: 0
};

const useStyles = makeStyles((theme: ThemeType) => ({
  root: {},

  withDesc: {
    height: "auto",
    padding: 0
  },

  menuWithDropdownItem: {
    position: "relative"
  },

  checkbox: {
    height: "auto",
    width: "auto",
    marginRight: theme.spacing()
  },

  dropdownItem: {
    width: "20%",
    height: "100%",
    position: "absolute",
    top: 0,
    right: 0,
    cursor: "pointer",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  },

  dropdownArrow: {
    transition: "all 0.5s ease-in-out"
  },

  dropdownArrowOpen: {
    transform: "rotate(180deg)"
  },

  desc: {
    flex: "0",
    position: "relative",
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    textAlign: "right"
  }
}));
